import ConsumerTable from "./consumerTable.container"

export default ConsumerTable
